"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Styles = exports.CSS = void 0;
exports.CSS = {
    container: 'c-AutoCompleteMenu',
    item: 'c-AutoCompleteMenu__Item',
    highlighted: 'c-AutoCompleteMenu--Highlighted'
};
exports.Styles = {
    [exports.CSS.highlighted]: {
        'font-weight': 'bold'
    }
};
//# sourceMappingURL=autocomplete.menu.style.js.map